module.exports = __webpack_public_path__ + "img/cwzx.698e86ab.svg";